import React from "react";
import { ListGroup, Button, Spinner, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faTrashAlt,
  faFileAlt,
  faClock,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import Markdown from "markdown-to-jsx";

// Custom PreBlock component for markdown code blocks
const PreBlock = ({ children, ...rest }) => {
  if ("type" in children && children["type"] === "code") {
    const props = children["props"];
    return <pre {...rest}><code {...props}>{props.children}</code></pre>;
  }
  return <pre {...rest}>{children}</pre>;
};

const AnalysisList = ({ analyses, isLoading, onView, onDelete, onBack }) => {
  if (isLoading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-light">Loading saved analyses...</p>
      </div>
    );
  }

  if (!analyses || analyses.length === 0) {
    return (
      <Alert
        variant="info"
        className="dark-alert mb-4"
        style={{
          background: "rgba(13, 202, 240, 0.1)",
          border: "1px solid rgba(13, 202, 240, 0.2)",
          color: "#ffffff",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderRadius: "8px",
        }}
      >
        <Alert.Heading className="h5 mb-2">No Saved Analyses</Alert.Heading>
        <p className="mb-0">
          You haven't saved any contract analyses yet. Upload and analyze a contract to get started.
        </p>
      </Alert>
    );
  }

  return (
    <div>
      <h5 className="text-light mb-4">Your Saved Analyses</h5>
      <div className="saved-analyses-list">
        {analyses.map((analysis) => (
          <div
            key={analysis.id}
            className="mb-3 p-3"
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.08)";
              e.currentTarget.style.border = "1px solid rgba(255, 255, 255, 0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
              e.currentTarget.style.border = "1px solid rgba(255, 255, 255, 0.08)";
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="d-flex align-items-center mb-2">
                  <FontAwesomeIcon
                    icon={faFileAlt}
                    className="me-2"
                    style={{ color: "var(--accent-blue)" }}
                  />
                  <h5 className="text-light mb-0">{analysis.file_name || "Unnamed Contract"}</h5>
                </div>
{analysis.description && (
                  <p className="text-light mb-2 small">
                    <Markdown
                      options={{
                        overrides: {
                          pre: PreBlock,
                          p: {
                            props: {
                              style: {
                                color: "#fff",
                                margin: 0
                              }
                            }
                          },
                          h1: {
                            props: {
                              style: {
                                fontSize: "1em",
                                color: "#fff"
                              }
                            }
                          },
                          h2: {
                            props: {
                              style: {
                                fontSize: "1em",
                                color: "#fff"
                              }
                            }
                          }
                        }
                      }}
                    >
                      {analysis.description}
                    </Markdown>
                  </p>
                )}
                <div className="d-flex align-items-center text-muted small">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                  <span className="me-3">
                    {new Date(analysis.created_at).toLocaleDateString()}
                  </span>
                  <FontAwesomeIcon icon={faClock} className="me-1" />
                  <span>
                    {new Date(analysis.created_at).toLocaleTimeString()}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <Button
                  variant="outline-primary"
                  className="dark-outline-button me-2"
                  onClick={() => onView(analysis)}
                  title="View Analysis"
                  style={{
                    background: "rgba(255, 255, 255, 0.05)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    color: "var(--text-light)",
                    borderRadius: "8px",
                    padding: "8px 12px",
                  }}
                >
                  <FontAwesomeIcon icon={faEye} />
                </Button>
                <Button
                  variant="outline-danger"
                  onClick={() => onDelete(analysis.id)}
                  title="Delete Analysis"
                  style={{
                    background: "rgba(255, 255, 255, 0.05)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    color: "var(--text-light)",
                    borderRadius: "8px",
                    padding: "8px 12px",
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalysisList;